import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const ShareListingModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "ShareListingModalContainer" */
      './ShareListingModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
